<template>
  <div style="position:relative;">
    <!-- Modale conferma spesa con amount a 0 -->
    <wg-modal
      v-if="showAmountWarning"
      @closeModal="showAmountWarning = !showAmountWarning"
    >
      <div slot="body">
        <div class="com-anm22-app-text-xxl">
          {{
            $anm22.strLang(
              lang,
              "Add expense with null amount?",
              "Aggiungere spesa con valore nullo?"
            )
          }}
        </div>
        <div class="vertical-height-div" style="height:40px;"></div>
        <div
          class="wg-row"
          style="align-items:center;justify-content:flex-end;"
        >
          <input
            type="button"
            :class="['small']"
            :value="$anm22.strLang(lang, 'Confirm', 'Conferma')"
            @click="
              showAmountWarning = false;
              saveOutgo();
            "
          />
          <input
            type="button"
            :class="['small', 'com-anm22-button-red']"
            style="margin-left:auto;"
            :value="$anm22.strLang(lang, 'Cancel', 'Cancella')"
            @click="showAmountWarning = false"
          />
        </div>
      </div>
    </wg-modal>
    <!-- Modale date picker -->
    <wg-modal
      v-if="openPicker"
      :portal="true"
      :width="windowWidth > 700 ? '400px' : '90%'"
      @closeModal="openPicker = false"
    >
      <div slot="body">
        <world-date-picker
          @customFunction="setFromPicker"
          :from="outgo.outgoDate"
        ></world-date-picker>
      </div>
    </wg-modal>
    <!-- 
      Modal conferma cancellazione utente / immagine della spesa
     -->
    <wg-modal
      v-if="showConfirmDelete"
      @closeModal="showConfirmDelete = !showConfirmDelete"
    >
      <div slot="body">
        <div class="com-anm22-app-text-xxl">
          {{ confirmDeleteLabel }}
        </div>
        <div class="vertical-height-div" style="height:40px;"></div>
        <div
          class="wg-row"
          style="align-items:center;justify-content:flex-end;"
        >
          <div
            class="com-anm22-app-text-xl"
            style="cursor:pointer;color:#f00;font-weight:bold;"
            @click="confirmDeleteFunction"
          >
            {{ $anm22.strLang(lang, "CONFIRM", "CONFERMA") }}
          </div>
        </div>
      </div>
    </wg-modal>
    <!-- 
      Div a scomparsa, da mostrare esclusivamente in caso di nuova spesa, subito dopo il salvataggio
      per far inserire le foto all'utente
     -->
    <div v-if="tabToShow === 'fileUploader'" class="wg-row">
      <div class="wg-row">
        <div class="com-anm22-app-text-xl">
          {{ $anm22.strLang(lang, "Add attachments", "Aggiungi allegati") }}
        </div>
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12">
          <div class="wg-row">
            <div
              v-for="(image, index) in outgo.images"
              :key="'image' + index"
              style="position:relative;height:100px;width:100px;margin:5px;cursor:pointer;"
            >
              <!-- <img 
                  v-if="/\.(jpe?g|png|gif|svg)$/i.test(image)"
                  style="height:100%;width:100%;"
                  :src="$anm22.getImagePath(image, offline)"
                  @click="openPic(index)">
              <img
                  v-else
                  style="height:100%;width:100%;"
                  :src="$anm22.icons.getWorldIcon('fileDefault')"
                  @click="openFile(image)"> -->
              <template v-if="typeof image === 'string'">
                <img
                  v-if="/\.(jpe?g|png|gif|svg)$/i.test(image)"
                  style="height:100%;width:100%;cursor:default"
                  :src="$anm22.getImagePath(image, offline)"
                />
                <img
                  v-else
                  style="height:100%;width:100%;cursor:default"
                  :src="$anm22.icons.getWorldIcon('fileDefault')"
                />
              </template>
              <img
                v-else
                style="height:100%;width:100%;cursor:default"
                :src="image.src"
              />
              <img
                v-if="!isImageSynchronized(image)"
                :src="$anm22.icons.getWorldIcon('offline')"
                class="com-anm22-app-img-fixed-height-m image-icon"
                style="top:3px;left:3px;"
                :title="
                  $anm22.strLang(lang, 'Not synchronized', 'Non sincronizzato')
                "
              />
              <img
                v-if="!offline"
                class="com-anm22-app-img-fixed-height-m"
                style="position:absolute;top:3px;right:3px;"
                :src="$anm22.icons.getWorldIcon('deleteBin')"
                @click="openConfirmDeleteImage(index)"
              />
            </div>
            <anm22-file-uploader
              :uploadUrl="
                'outgo/uploadImage?idWorldOutgo=' + outgo.idWorldOutgo
              "
              :addImageBeforeUpload="addImageBeforeUpload"
              :onSuccess="addImage"
              :syncData="{ class: 'WorldOutgo', objId: outgo.idWorldOutgo }"
            ></anm22-file-uploader>
          </div>
        </div>
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="wg-row">
        <input
          type="button"
          :class="['small']"
          :value="$anm22.strLang(lang, 'Close', 'Chiudi')"
          @click="$anm22.eventBus.$emit('wg-modal-close')"
        />
      </div>
    </div>
    <!-- 
      Div a scomparsa per mostrare un'immagine utilizzando tutta la finestra popup
     -->
    <div v-if="tabToShow === 'pic'" class="wg-row pic-viewer">
      <img
        style="width:100%;height:100%;object-fit:contain;object-position:center;cursor:zoom-out;"
        :src="
          typeof picToShow === 'string'
            ? $anm22.getImagePath(picToShow, offline)
            : picToShow.src
        "
        @click="closePic"
      />
    </div>
    <!-- 
      Div principale, gestione spesa mediante modal
     -->
    <div v-show="tabToShow === 'default'" class="wg-row">
      <!-- Form validation - errors -->
      <div class="wg-row">
        <div
          v-for="(error, index) in errors"
          :key="'error-' + index"
          class="com-anm22-app-text-l"
          style="margin-bottom:10px;color:#f00;"
        >
          {{ error.text }}
        </div>
      </div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "Date", "Data") }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <div class="wg-row">
            <div :class="['wg-col', 'wg-xs-12']" style="padding:0 2px;">
              <div
                v-if="mode === 'new' || mode === 'edit'"
                @click="openPicker = !openPicker"
                class="input-date-picker-label"
                :class="[
                  'com-anm22-app-input-date',
                  errors['outgoDate'] ? 'input-error' : '',
                ]"
                style="margin-top:5px;"
              >
                {{
                  $moment
                    .unix(outgo.outgoDate)
                    .utc()
                    .format("DD-MM-YYYY")
                }}
              </div>
              <div v-else class="com-anm22-app-text-m" style="margin-top:5px;">
                {{
                  $moment
                    .unix(outgo.outgoDate)
                    .utc()
                    .format("DD-MM-YYYY")
                }}
              </div>
            </div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "Category", "Categoria") }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <div class="wg-row">
            <div class="wg-col wg-xs-12" style="padding:0 2px;">
              <select
                v-if="mode === 'new' || mode === 'edit'"
                class="com-anm22-app-select"
                v-model="category"
              >
                <option value="0">{{
                  $anm22.strLang(lang, "Select", "Seleziona")
                }}</option>
                <option value="1">{{
                  $anm22.strLang(lang, "ATM", "Prelievo")
                }}</option>
                <option
                  v-for="(category, index) in categories"
                  :key="'cat-' + index"
                  :value="category.idWorldOutgoCategory"
                >
                  {{ category.name }}
                </option>
              </select>
              <div v-else class="com-anm22-app-text-m" style="margin-top:5px;">
                {{ category }}
              </div>
            </div>
          </div>
        </div>
        <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "Description", "Descrizione") }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <div class="wg-row">
            <div class="wg-col wg-xs-12" style="padding:0 2px;">
              <textarea
                v-if="mode === 'new' || mode === 'edit'"
                class="com-anm22-app-textarea"
                style="height:105px;margin:0;"
                :placeholder="
                  $anm22.strLang(lang, 'Description', 'Descrizione')
                "
                v-model.lazy="outgo.description"
              >
              </textarea>
              <div v-else class="com-anm22-app-text-m" style="margin-top:5px;">
                {{ outgo.description }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <!-- Utente spesa -->
      <!-- search bar -->
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "User", "Utente") }}
          </div>
          <template v-if="mode === 'edit'">
            <div class="vertical-height-div" style="height:5px;"></div>
            <wg-search
              :placeholder="$anm22.strLang(lang, 'User', 'Utente')"
              :url="'user/getByNameInProject'"
              :clickFn="changeUser"
              :debounceTime="2000"
              :attachedData="{ projectId: projectId }"
            ></wg-search>
          </template>
        </div>
        <div class="vertical-height-div wg-sm-none" style="height:5px;"></div>
        <div
          class="wg-col wg-xs-12 wg-sm-6"
          style="display:flex;align-items:center;"
        >
          <div
            v-if="outgoUser"
            class="wg-row"
            style="flex-wrap:nowrap;align-items:center;"
          >
            <div
              class="com-anm22-app-horizontal-space wg-xs-none wg-sm-"
              style="width:10px;"
            ></div>
            <div
              v-if="outgoUser"
              style="min-width:30px;width:30px;height:30px;margin-right:5px;"
            >
              <world-object-icon :type="'user'" :obj="outgoUser" :isImg="true">
              </world-object-icon>
            </div>
            <!-- <img 
                :src="outgoUser.image || $anm22.icons.getWorldIcon('userDefault')"
                :title="outgoUser.name"
                class="com-anm22-app-img-fixed-height-l com-anm22-round "
            > -->
            <div>
              <div class="com-anm22-app-text-m" style="font-weight:bold;">
                {{ outgoUser.name }}
              </div>
              <!--
              <template v-if="mode === 'edit'">
                <div class="vertical-height-div" style="height:2px;"></div>
                <div 
                    class="display-flex" 
                    style="align-items:center;cursor:pointer;" 
                    @click="openConfirmDeleteUser">
                  <img class="com-anm22-app-img-fixed-height-s" :src="$anm22.icons.getWorldIcon('deleteRed')">
                  <div class="com-anm22-app-horizontal-space" style="width:5px;"></div>
                  <div class="com-anm22-app-text-m">
                    {{ $anm22.strLang(lang, 'Remove', 'Rimuovi') }}
                  </div>
                </div>
              </template>
              -->
            </div>
          </div>
        </div>
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-8 wg-sm-6">
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "Total", "Totale") }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <div class="wg-row">
            <div class="wg-col wg-xs-12" style="padding:0 2px;">
              <input
                v-if="mode === 'new' || mode === 'edit'"
                class="com-anm22-app-input-number"
                type="number"
                min="0"
                @focus="$event.target.select()"
                v-model="outgo.amount"
              />
              <div v-else class="com-anm22-app-text-m" style="margin-top:5px;">
                {{ outgo.amount }}
              </div>
            </div>
          </div>
        </div>
        <div class="wg-col wg-xs-4 wg-sm-6">
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "Currency", "Valuta") }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <div class="wg-row">
            <div class="wg-col wg-xs-12" style="padding:0 2px;">
              <select
                v-if="mode === 'new' || mode === 'edit'"
                class="com-anm22-app-select"
                v-model="outgo.currencyType"
              >
                <option
                  v-for="(currency,
                  key,
                  index) in $anm22.tableClasses.worldCurrencyType().getAll()"
                  :key="'cur-' + index"
                  :value="key"
                >
                  {{ currency[lang] }}
                </option>
              </select>
              <div v-else class="com-anm22-app-text-m" style="margin-top:5px;">
                {{
                  $anm22.tableClasses
                    .worldCurrencyType()
                    .getById(outgo.currencyType)[lang]
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "Payment method", "Metodo di pagamento") }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <div class="wg-row">
            <div class="wg-col wg-xs-12" style="padding:0 2px;">
              <select
                v-if="mode === 'new' || mode === 'edit'"
                class="com-anm22-app-select"
                v-model="paymentMode"
              >
                <option value="0">{{
                  $anm22.strLang(lang, "Cash", "Contanti")
                }}</option>
                <option
                  v-for="(card, index) in cards"
                  :key="'card-' + index"
                  :disabled="card.expirationDate < $moment.utc().format('X')"
                  :style="
                    card.expirationDate < $moment.utc().format('X')
                      ? 'color:red;'
                      : ''
                  "
                  :value="'c|' + card.idWorldCard"
                >
                  {{ getCardLabel(card) }}
                </option>
                <option
                  v-for="(ba, index) in bankAccounts"
                  :key="'ba-' + index"
                  :disabled="ba.expirationDate < $moment.utc().format('X')"
                  :style="
                    ba.expirationDate < $moment.utc().format('X')
                      ? 'color:red;'
                      : ''
                  "
                  :value="'b|' + ba.idWorldBankAccount"
                >
                  {{ ba.bank }}
                </option>
              </select>
              <!-- <div 
                  v-else
                  class="com-anm22-app-text-m" 
                  style="margin-top:5px;">
                {{ paymentMode }}
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <!-- Altre opzioni a scomparsa -->
      <template v-if="userPermission <= 3">
        <div class="vertical-height-div" style="height:10px;"></div>
        <input
          type="button"
          :class="['small']"
          :value="
            !showMoreOptions
              ? $anm22.strLang(lang, 'Show more fields', 'Mostra più campi')
              : $anm22.strLang(lang, 'Hide fields', 'Nascondi campi')
          "
          :disabled="Object.keys(errors).length > 0"
          @click="showMoreOptions = !showMoreOptions"
        />
        <div v-if="showMoreOptions" class="wg-row">
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <div class="wg-col wg-xs-12 wg-sm-6">
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, "Tax amount", "Valore tasse") }}
              </div>
              <div class="vertical-height-div" style="height:5px;"></div>
              <div class="wg-row">
                <div class="wg-col wg-xs-12" style="padding:0 2px;">
                  <input
                    v-if="mode === 'new' || mode === 'edit'"
                    :placeholder="
                      $anm22.strLang(lang, 'Tax amount', 'Valore tasse')
                    "
                    class="com-anm22-app-input-number"
                    type="number"
                    min="0"
                    step="0.01"
                    v-model="outgo.taxValue"
                  />
                  <div
                    v-else
                    class="com-anm22-app-text-m"
                    style="margin-top:5px;"
                  >
                    {{ outgo.taxValue }}
                  </div>
                </div>
              </div>
            </div>
            <div
              class="vertical-height-div wg-sm-none"
              style="height:10px;"
            ></div>
            <div class="wg-col wg-xs-12 wg-sm-6">
              <div class="com-anm22-app-text-l">
                {{
                  $anm22.strLang(lang, "Tax percentage", "Percentuale tasse")
                }}
              </div>
              <div class="vertical-height-div" style="height:5px;"></div>
              <div class="wg-row">
                <div class="wg-col wg-xs-12" style="padding:0 2px;">
                  <input
                    v-if="mode === 'new' || mode === 'edit'"
                    :placeholder="
                      $anm22.strLang(lang, 'Percentage', 'Percentuale')
                    "
                    class="com-anm22-app-input-number"
                    type="number"
                    min="0"
                    step="0.1"
                    v-model="outgo.taxPercentage"
                  />
                  <div
                    v-else
                    class="com-anm22-app-text-m"
                    style="margin-top:5px;"
                  >
                    {{ outgo.taxPercentage }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <div class="wg-col wg-xs-12 wg-sm-6">
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, "Tips", "Mancia") }}
              </div>
              <div class="vertical-height-div" style="height:5px;"></div>
              <div class="wg-row">
                <div class="wg-col wg-xs-12" style="padding:0 2px;">
                  <input
                    v-if="mode === 'new' || mode === 'edit'"
                    :placeholder="$anm22.strLang(lang, 'Tips', 'Mancia')"
                    class="com-anm22-app-input-number"
                    type="number"
                    min="0"
                    step="0.01"
                    v-model="outgo.tipsValue"
                  />
                  <div
                    v-else
                    class="com-anm22-app-text-m"
                    style="margin-top:5px;"
                  >
                    {{ outgo.tipsValue }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row">
            <div class="wg-col wg-xs-8 wg-sm-6">
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, "Total", "Totale convertito") }}
              </div>
              <div class="vertical-height-div" style="height:5px;"></div>
              <div class="wg-row">
                <div class="wg-col wg-xs-12" style="padding:0 2px;">
                  <input
                    v-if="mode === 'new' || mode === 'edit'"
                    :placeholder="
                      $anm22.strLang(lang, 'Total', 'Totale convertito')
                    "
                    class="com-anm22-app-input-number"
                    type="number"
                    step="0.01"
                    v-model="outgo.exchangeValue"
                  />
                  <div
                    v-else
                    class="com-anm22-app-text-m"
                    style="margin-top:5px;"
                  >
                    {{ outgo.exchangeValue }}
                  </div>
                </div>
              </div>
            </div>
            <div class="wg-col wg-xs-4 wg-sm-6">
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, "Currency", "Valuta") }}
              </div>
              <div class="vertical-height-div" style="height:5px;"></div>
              <div class="wg-row">
                <div class="wg-col wg-xs-12" style="padding:0 2px;">
                  <select
                    v-if="mode === 'new' || mode === 'edit'"
                    class="com-anm22-app-select"
                    v-model="outgo.exchangeCurrency"
                  >
                    <option
                      v-for="(currency,
                      key,
                      index) in $anm22.tableClasses
                        .worldCurrencyType()
                        .getAll()"
                      :key="'cur-' + index"
                      :value="key"
                    >
                      {{ currency[lang] }}
                    </option>
                  </select>
                  <div
                    v-else
                    class="com-anm22-app-text-m"
                    style="margin-top:5px;"
                  >
                    {{
                      $anm22.tableClasses
                        .worldCurrencyType()
                        .getById(outgo.exchangeCurrency)[lang]
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <div class="wg-col wg-xs-8 wg-sm-6">
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, "Exchange rate", "Tasso di cambio") }}
              </div>
              <div class="vertical-height-div" style="height:5px;"></div>
              <div class="wg-row">
                <div class="wg-col wg-xs-12" style="padding:0 2px;">
                  <input
                    v-if="mode === 'new' || mode === 'edit'"
                    :placeholder="
                      $anm22.strLang(lang, 'Exchange rate', 'Tasso di cambio')
                    "
                    class="com-anm22-app-input-number"
                    type="number"
                    step="0.0001"
                    v-model="outgo.exchangeRate"
                  />
                  <div
                    v-else
                    class="com-anm22-app-text-m"
                    style="margin-top:5px;"
                  >
                    {{ outgo.exchangeRate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="wg-col wg-xs-4 wg-sm-6">
              <div class="vertical-height-div" style="height:22px;"></div>
              <div class="wg-row">
                <div class="wg-col wg-xs-12" style="padding:0 2px;">
                  <div
                    class="expense-xe-converter-button"
                    @click="openXeConverter"
                  >
                    {{ $anm22.strLang(lang, "Converter", "Convertitore") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div v-if="mode !== 'view'" class="wg-row">
        <input
          type="button"
          :class="[
            'small',
            Object.keys(errors).length > 0 ? 'button-disabled' : '',
          ]"
          :value="
            mode === 'edit'
              ? $anm22.strLang(lang, 'Save', 'Salva')
              : $anm22.strLang(lang, 'Create', 'Crea')
          "
          :disabled="Object.keys(errors).length > 0"
          @click="verifyAmount"
        />
      </div>
      <template v-if="mode !== 'new'">
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row">
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, "Attachments", "Allegati") }}
          </div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <div class="wg-col wg-xs-12">
            <div class="wg-row">
              <div
                v-for="(image, index) in outgo.images"
                :key="'image' + index"
                style="position:relative;height:100px;width:100px;margin:5px;cursor:pointer;"
              >
                <template v-if="typeof image === 'string'">
                  <img
                    v-if="/\.(jpe?g|png|gif|svg)$/i.test(image)"
                    style="height:100%;width:100%;"
                    :src="$anm22.getImagePath(image, offline)"
                    @click="openPic(index)"
                  />
                  <img
                    v-else
                    style="height:100%;width:100%;"
                    :src="$anm22.icons.getWorldIcon('fileDefault')"
                    @click="openFile(image)"
                  />
                </template>
                <img
                  v-else
                  style="height:100%;width:100%;"
                  :src="image.src"
                  @click="openPic(index)"
                />
                <img
                  v-if="!isImageSynchronized(image)"
                  :src="$anm22.icons.getWorldIcon('offline')"
                  class="com-anm22-app-img-fixed-height-m image-icon"
                  style="top:3px;left:3px;"
                  :title="
                    $anm22.strLang(
                      lang,
                      'Not synchronized',
                      'Non sincronizzato'
                    )
                  "
                />
                <img
                  v-if="!offline && mode === 'edit'"
                  class="com-anm22-app-img-fixed-height-m image-icon"
                  style="top:3px;right:3px;"
                  :src="$anm22.icons.getWorldIcon('deleteBin')"
                  @click="openConfirmDeleteImage(index)"
                />
              </div>
              <anm22-file-uploader
                v-if="canAddReceipt"
                :uploadUrl="
                  'outgo/uploadImage?idWorldOutgo=' + outgo.idWorldOutgo
                "
                :addImageBeforeUpload="addImageBeforeUpload"
                :onSuccess="addImage"
                :syncData="{ class: 'WorldOutgo', objId: outgo.idWorldOutgo }"
              ></anm22-file-uploader>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";
import Anm22FileUploader from "../../../../../world/spa/components/Anm22FileUploaderInline.vue";
import WorldDatePicker from "../../../../../world/spa/components/WorldDatePicker.vue";

export default {
  props: {
    projectId: [Number, String],
    outgoRef: Object,
    mode: String,
    userPermission: Number,
  },
  data() {
    return {
      openPicker: false,
      outgo: { ...this.outgoRef },
      outgoTemp: "",
      debouncing: false,
      // mode: 'new',
      tabToShow: "default",
      //Validation errors - msgs
      errors: {},
      showMoreOptions: false,
      picToShow: null,
      //Conferma cancellazione
      showConfirmDelete: false,
      confirmDeleteLabel: "",
      confirmDeleteFunction: "",
      showAmountWarning: false,
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user,
      offline: (state) => state.offline.isOffline,
      windowWidth: (state) => state.windowWidth,
    }),
    project() {
      return this.$store.getters["projects/get"](this.projectId);
    },
    licenses() {
      return this.$store.getters["employments/getByUser"](this.user.idWorldUser)
        .filter((e) => this.project.developers.includes(e.work))
        .map((e) => this.$store.getters["licenses/getByWork"](e.work))
        .filter((l) => l);
    },
    reports() {
      return this.$store.getters["employeeExpenseReports/getAll"].filter(
        (r) =>
          this.project.users.includes(r.user) &&
          this.project.developers.includes(r.work)
      );
    },
    cards() {
      //Recupero le carte mie e, se diverso, dell'utente della spesa
      let result = [];
      this.$store.getters["userCardAssocs/getByUser"](
        this.user.idWorldUser
      ).forEach((assoc) => {
        result.push(this.$store.getters["cards/get"](assoc.card));
      });
      if (this.user.idWorldUser !== this.outgo.user) {
        this.$store.getters["userCardAssocs/getByUser"](
          this.outgo.user
        ).forEach((assoc) => {
          result.push(this.$store.getters["cards/get"](assoc.card));
        });
      }
      //Recupero le carte aziendali
      this.$store.getters["employments/getByUser"](
        this.user.idWorldUser
      ).forEach((e) => {
        this.$store.getters["employmentCardAssocs/getByEmployment"](
          e.work,
          e.user
        ).forEach((assoc) => {
          result.push(this.$store.getters["cards/get"](assoc.card));
        });
      });
      if (this.user.idWorldUser !== this.outgo.user) {
        this.$store.getters["employments/getByUser"](
          this.user.idWorldUser
        ).forEach((e) => {
          this.$store.getters["employmentCardAssocs/getByEmployment"](
            e.work,
            this.outgo.user
          ).forEach((assoc) => {
            result.push(this.$store.getters["cards/get"](assoc.card));
          });
        });
      }
      //Filtri
      result = result.filter((c) => !Number(c.disabled));
      return result;
    },
    bankAccounts() {
      let result = [];
      this.$store.getters["userBankAccountAssocs/getByUser"](
        this.user.idWorldUser
      ).forEach((assoc) => {
        result.push(this.$store.getters["bankAccounts/get"](assoc.bankAccount));
      });
      if (this.user.idWorldUser !== this.outgo.user) {
        this.$store.getters["userBankAccountAssocs/getByUser"](
          this.outgo.user
        ).forEach((assoc) => {
          result.push(
            this.$store.getters["bankAccounts/get"](assoc.bankAccount)
          );
        });
      }
      //Recupero le banche aziendali
      this.$store.getters["employments/getByUser"](
        this.user.idWorldUser
      ).forEach((e) => {
        this.$store.getters["employmentBankAccountAssocs/getByEmployment"](
          e.work,
          e.user
        ).forEach((assoc) => {
          result.push(
            this.$store.getters["bankAccounts/get"](assoc.bankAccount)
          );
        });
      });
      if (this.user.idWorldUser !== this.outgo.user) {
        this.$store.getters["employments/getByUser"](
          this.user.idWorldUser
        ).forEach((e) => {
          this.$store.getters["employmentBankAccountAssocs/getByEmployment"](
            e.work,
            this.outgo.user
          ).forEach((assoc) => {
            result.push(
              this.$store.getters["bankAccounts/get"](assoc.bankAccount)
            );
          });
        });
      }
      //Filtri
      result = result.filter((b) => !Number(b.disabled));
      return result;
    },
    categories() {
      /**
       * Se è presente una gestione personalizzata delle categorie allora queste vengono determinate in base
       * alla personalizzazione, altrimenti vengono mostrate quelle associate al singolo work
       */
      return this.licenses.reduce((arr, l) => {
        if (
          l.config &&
          l.config.tasks &&
          l.config.tasks.expenses &&
          l.config.tasks.expenses["custom-outgo-categories"]
        ) {
          return arr.concat(
            this.$anm22[l.config.tasks.expenses["custom-outgo-categories"]](
              this,
              { projectId: this.projectId }
            )
          );
        } else {
          return arr.concat(
            this.$store.getters["outgoCategories/getBySupplier"](l.work)
          );
        }
      }, []);
    },
    outgoUser() {
      return this.$store.getters["users/get"](this.outgo.user);
    },
    outgoDate: {
      get() {
        return this.$moment
          .unix(this.outgo.outgoDate)
          .utc()
          .format("YYYY-MM-DD");
      },
      set(newVal) {
        this.outgoTemp = this.$anm22.parseInputDate(newVal);
        this.debouncing = true;
        this.setOutgoDate_d(this.outgoTemp);
      },
    },
    paymentMode: {
      get() {
        if (this.outgo.card) {
          return "c|" + this.outgo.card;
        } else if (this.outgo.bankAccount) {
          return "b|" + this.outgo.bankAccount;
        } else {
          return 0;
        }
      },
      set(newVal) {
        let data = newVal.split("|");
        switch (data[0]) {
          case "c":
            this.outgo.paymentMode = 1;
            this.outgo.card = Number(data[1]);
            this.outgo.bankAccount = "";
            break;
          case "b":
            this.outgo.paymentMode = 2;
            this.outgo.bankAccount = Number(data[1]);
            this.outgo.card = "";
            break;
          default:
            this.outgo.paymentMode = 0;
            this.outgo.bankAccount = "";
            this.outgo.card = "";
        }
      },
    },
    category: {
      get() {
        return this.outgo.category || 0;
      },
      set(newVal) {
        if (newVal !== 0) {
          this.outgo.category = newVal;
        }
      },
    },
    canAddReceipt() {
      return this.licenses
        .filter(
          (l) =>
            l.config.tasks &&
            l.config.tasks.expenses &&
            l.config.tasks.expenses["image-rules"]
        )
        .reduce(
          (result, l) =>
            result &&
            this.$anm22[l.config.tasks.expenses["image-rules"]](
              this,
              this.outgo
            ),
          true
        );
    },
  },
  methods: {
    isImageSynchronized(image) {
      return this.$store.getters["offline/isSynchronized"](
        this.$anm22.MD5("WorldOutgoImage" + image.syncId)
      );
    },
    setOutgoDate(date) {
      this.debouncing = false;
      // Rimuovo eventuali errori collegati alla data
      if (this.errors["outgoDate"]) {
        delete this.errors["outgoDate"];
      }
      //Verificare che la data sia accettabile
      const newDate = this.$moment.utc(date);
      const now = this.$moment.utc();
      if (
        newDate.isBefore(now.clone().subtract(45, "days")) ||
        newDate.isAfter(now.clone().add(15, "days"))
      ) {
        this.$set(this.errors, "outgoDate", {
          text: this.$anm22.strLang(
            this.lang,
            "Expense date cannot be more than 45 days in the past or 15 days in the future",
            "La data della spesa non può essere più di 45 giorni nel passato o 15 giorni nel futuro"
          ),
        });
      }
      this.outgo.outgoDate = newDate.unix();
    },
    setFromPicker(newVal) {
      this.setOutgoDate(newVal);
      this.openPicker = false;
    },
    setOutgoDate_d: _.debounce(function(date) {
      if (this.debouncing) {
        this.setOutgoDate(date);
      }
    }, 100),
    getCardLabel(card) {
      let string = "";
      if (card.name !== "") {
        string += card.name + " - ";
      }
      const cardType = this.$store.getters["cardTypes/get"](card.cardType);
      if (cardType && cardType.system) {
        string += this.$anm22.tableClasses
          .processingSystem()
          .getById(cardType.system)[this.lang];
      }
      string += " - " + card.number;
      return string;
    },
    verifyAmount() {
      if (this.outgo.amount == 0) {
        this.showAmountWarning = true;
      } else {
        this.saveOutgo();
      }
    },
    async saveOutgo() {
      if (this.debouncing) {
        this.setOutgoDate(this.outgoTemp);
      }
      if (Object.keys(this.errors).length > 0) {
        return;
      }
      if (this.mode === "new") {
        this.outgo.idWorldOutgo = this.outgo.dbKey = this.$anm22.genLocalId();
      }
      try {
        // if(isNaN(this.outgo.idWorldOutgo) && this.mode === 'edit') {
        //   throw new Error('continue offline...');
        // }
        const response = await this.$http.post(
          "outgo/save",
          {
            projectId: this.projectId,
            outgo: this.outgo,
          },
          {
            withCredentials: true,
          }
        );
        this.outgo = response.data.outgo;
        //Salvo in db locale i nuovi dati
        await this.$store.dispatch("outgoes/update", {
          vlf: this.$vlf("outgoes"),
          objs: [response.data.outgo],
        });
      } catch (e) {
        //Offline
        await Promise.all([
          this.$store.dispatch("outgoes/update", {
            vlf: this.$vlf("outgoes"),
            objs: [this.outgo],
          }),
          this.$store.dispatch("offline/saveSyncTuple", {
            _vue: this,
            _class: "WorldOutgo",
            _table: "outgoes",
            mode: this.mode,
            type: "obj",
            obj: this.outgo,
          }),
          // this.$anm22.saveSyncTuple(this, 'WorldOutgo', this.mode, this.outgo)
        ]);
      } finally {
        if (this.mode === "new") {
          //Mostro la pagina di upload foto -> poi chiudo il popup una volta finito di salvare le foto
          this.tabToShow = "fileUploader";
        } else {
          this.$anm22.eventBus.$emit("wg-modal-close");
        }
      }
    },
    changeUser(idUser) {
      this.$http
        .post(
          "outgo/setUser",
          {
            idWorldOutgo: this.outgo.idWorldOutgo,
            idWorldUser: idUser,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          // if(isNaN(this.outgo.idWorldOutgo)) {
          //   throw new Error('continue offline...');
          // }
          this.outgo.user = idUser;
          this.$store.dispatch("outgoes/update", {
            vlf: this.$vlf("outgoes"),
            objs: [this.outgo],
          });
        })
        .catch((error) => {
          // Update to sync
          this.outgo.user = idUser;
          Promise.all([
            this.$store.dispatch("outgoes/update", {
              vlf: this.$vlf("outgoes"),
              objs: [this.outgo],
            }),
            this.$store.dispatch("offline/saveSyncTuple", {
              _vue: this,
              _class: "WorldOutgo",
              _table: "outgoes",
              mode: "edit",
              type: "obj",
              obj: this.outgo,
            }),
            // this.$anm22.saveSyncTuple(this, 'WorldOutgo', 'edit', this.outgo)
          ]).catch((error) => console.log(error));
        });
    },
    openConfirmDeleteUser() {
      this.confirmDeleteLabel = this.$anm22.strLang(
        this.lang,
        "Delete user?",
        "Rimuovere utente?"
      );
      this.confirmDeleteFunction = () => {
        return this.removeUser();
      };
      this.showConfirmDelete = true;
    },
    removeUser() {
      this.showConfirmDelete = false;
      this.$http
        .post(
          "outgo/removeUser",
          {
            idWorldOutgo: this.outgo.idWorldOutgo,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          // if(isNaN(this.outgo.idWorldOutgo)) {
          //   throw new Error('continue offline...');
          // }
          this.outgo.user = "";
          this.$store.dispatch("outgoes/update", {
            vlf: this.$vlf("outgoes"),
            objs: [this.outgo],
          });
        })
        .catch((error) => {
          // Update to sync
          this.outgo.user = "";
          Promise.all([
            this.$store.dispatch("outgoes/update", {
              vlf: this.$vlf("outgoes"),
              objs: [this.outgo],
            }),
            this.$store.dispatch("offline/saveSyncTuple", {
              _vue: this,
              _class: "WorldOutgo",
              _table: "outgoes",
              mode: "edit",
              type: "obj",
              obj: this.outgo,
            }),
            // this.$anm22.saveSyncTuple(this, 'WorldOutgo', 'edit', this.outgo)
          ]).catch((error) => console.log(error));
        });
    },
    openXeConverter() {
      window.open(
        "http://www.xe.com/currencyconverter/convert/" +
          "?Amount=" +
          this.outgo.amount +
          "&From=" +
          this.outgo.currencyType +
          "&To=" +
          this.outgo.exchangeCurrency,
        "_blank"
      );
    },
    addImage(data) {
      //Usato con l'uploader per caricare le nuove immagini una volta inviate e salvate sul server

      // Rimuovo l'immagine dalla memoria locale
      var offlineImageKey = null;
      this.outgo.images.forEach(function(item, key) {
        if (item.syncId == data.localId) {
          offlineImageKey = key;
        }
      });
      if (offlineImageKey != null) {
        this.outgo.images.splice(offlineImageKey, 1);
      }
      this.$store.dispatch("offline/removeSyncTuples", {
        _vue: this,
        _class: "WorldOutgoImage",
        syncId: data.localId,
      });
      // Inserisco il riferimento all'immagine caricata
      this.outgo.images.push(data.url);
      this.$store.dispatch("outgoes/update", {
        vlf: this.$vlf("outgoes"),
        objs: [this.outgo],
      });
    },
    addImageBeforeUpload(data) {
      const localId = data.localId;
      data.url.syncId = localId;
      /**
       * Il controller di sync restituisce la spesa aggiornata con l'url definitivo dell'immagine, per questo motivo
       * la tabella per aggiornare alla ricezione della risposta è outgoes
       */

      this.$store.dispatch("offline/saveSyncTuple", {
        _vue: this,
        _class: "WorldOutgoImage",
        _table: "outgoes",
        mode: "new",
        type: "file",
        obj: {
          syncId: localId,
          dbKey: localId,
          file: data.url.file,
          outgoId: this.outgo.idWorldOutgo,
        },
      });
      this.outgo.images.push(data.url);
      this.$store.dispatch("outgoes/update", {
        vlf: this.$vlf("outgoes"),
        objs: [this.outgo],
      });
    },
    openConfirmDeleteImage(index) {
      this.confirmDeleteLabel = this.$anm22.strLang(
        this.lang,
        "Delete image?",
        "Cancella immagine?"
      );
      this.confirmDeleteFunction = () => {
        return this.deleteImage(index);
      };
      this.showConfirmDelete = true;
    },
    deleteImage(index) {
      this.showConfirmDelete = false;
      this.$http
        .post(
          "outgo/deleteImage",
          {
            idWorldOutgo: this.outgo.idWorldOutgo,
            imageUrl: this.outgo.images[index],
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.outgo.images.splice(index, 1);
          this.$store.dispatch("outgoes/update", {
            vlf: this.$vlf("outgoes"),
            objs: [this.outgo],
          });
        })
        .catch((error) => {});
    },
    openPic(index) {
      const url = this.outgo.images[index];
      this.picToShow = url;
      this.tabToShow = "pic";
    },
    openFile(url) {
      window.open(this.$anm22.getImagePath(url), "_blank");
    },
    closePic() {
      this.tabToShow = "default";
      this.picToShow = null;
    },
  },
  components: {
    Anm22FileUploader,
    WorldDatePicker,
  },
};
</script>

<style lang="scss" scoped>
.button-disabled {
  opacity: 0.4;
  pointer-events: none;
}
.pic-viewer {
  height: calc(90vh - 90px);
  width: 100%;
  justify-content: center;
}
.input-date-picker-label {
  width: 100%;
  max-width: 300px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  box-sizing: border-box;
  padding: 10px;
  border-radius: 4px;
  display: block;
  box-shadow: none;
  background-color: #eee;
  border: 1px solid #eee;
  height: 36px;
  font-size: 12px;
  cursor: pointer;
}
.input-error {
  border: 1px solid #ff5252;
  background-color: #ff5252;
}
.image-icon {
  position: absolute;
  background-color: #fff;
  border-radius: 6px;
  padding: 2px;
}
</style>
